export default "__VITE_ASSET__DP658ZX___"